import { ICell }                   from 'rewire-grid';
import { Form, Modal }             from 'rewire-ui';
import { IEmployee, IJob, IShift } from '../DataTypes';
import scheduleInfoPanelModel      from './ScheduleInfoPanelModel';

export default abstract class InfoPanelViewModelBase<TState = unknown> extends Modal<TState> {
  form: Form;

  constructor() {
    super('', true);
  }

  abstract reset():  void;
  abstract load():   void;
  abstract undo():   void;
  abstract submit(): Promise<boolean>;

  get cell(): ICell | undefined {
    return scheduleInfoPanelModel.selectedCell;
  }

  get cellData(): IEmployee | IJob | IShift | undefined {
    return this.cell?.value;
  }
}
